import {Row} from 'antd';
import classes from '../Pages.module.css';
import DataField from './DataField';
import ExperienceEdit from './ExperienceEdit';


const Experience = (props) => {
    console.log("ExperienceProps is this ",props)
    return(
        !props.editMode
        ?
        props.data.map((data, index) => {
            return(
                <div key={index}>
                <p></p>
                <Row className={props.editMode ? classes['RowDEX'] : classes['RowD']}>
                    <DataField 
                        editMode={false} 
                        lg={12} 
                        md={24} 
                        name="company name" 
                        value={data.company_name} 
                    />
                    <DataField 
                        editMode={false} 
                        lg={12} 
                        md={24} 
                        options={props.ad.EMPLOYEE_DESIG_CODE} 
                        type="Select" 
                        name="designation" 
                        value={data.designation_code} 
                    />
                    <DataField 
                        editMode={false} 
                        lg={8} 
                        md={24} 
                        name="from date" 
                        value={data.from_date ? data.from_date.format('DD-MM-YYYY') : null} 
                    />
                    <DataField 
                        editMode={false} 
                        lg={8} 
                        md={24} 
                        name="to date" 
                        value={data.to_date ? data.to_date.format('DD-MM-YYYY') : null} 
                    />
                    <DataField 
                        editMode={false} 
                        lg={8} 
                        md={24} 
                        name="gross salary" 
                        value={data.gross_salary} 
                    />
                </Row>  
                <p></p>
            </div>
            
            );
        })
           
        :
        <>
            <p></p>
            <ExperienceEdit desigOptions = {props.ad.EMPLOYEE_DESIG_CODE} data = {props.data} setData = {props.setData} />
        </>
    );
}

export default Experience